// extracted by mini-css-extract-plugin
module.exports = {"TicketInspector":"TicketInspector__1HpBqSyrXnzl","scrollerWrapper":"scrollerWrapper__Fc975RoxPr4a","bottomMargin":"bottomMargin__1WPrhgINDHMs"};